export const analyticalVariablesMessagesEn = {
  // Analytical Variable Modal
  'projects.researchAssistant.analyticalVariable.modal.title': 'View analytical variable',
  'projects.researchAssistant.analyticalVariable.modal.tabs.definition': 'Definition',
  'projects.researchAssistant.analyticalVariable.modal.tabs.sql': 'SQL',
  'projects.researchAssistant.analyticalVariable.modal.tabs.data': 'Data',
  'projects.researchAssistant.analyticalVariable.modal.tabs.verification': 'Verification',
  'projects.researchAssistant.analyticalVariable.modal.tabs.sqlTooltip':
    'SQL generation not yet implemented',
  'projects.researchAssistant.analyticalVariable.modal.tabs.dataTooltip':
    'Data preview not yet implemented',
  'projects.researchAssistant.analyticalVariable.modal.tabs.verificationTooltip':
    'Verification not yet implemented',

  // Definition Tab
  'projects.researchAssistant.analyticalVariable.definition.name': 'Name',
  'projects.researchAssistant.analyticalVariable.definition.description': 'Description',
  'projects.researchAssistant.analyticalVariable.definition.outputType': 'Output Type',
  'projects.researchAssistant.analyticalVariable.definition.created': 'Created',
  'projects.researchAssistant.analyticalVariable.definition.notAvailable': 'Not available',
  'projects.researchAssistant.analyticalVariable.definition.variableComponents':
    'Variable Components ({eventCount})',
  'projects.researchAssistant.analyticalVariable.definition.eventDetails': 'Event details:',
  'projects.researchAssistant.analyticalVariable.definition.noEventsDefined': 'No events defined',
  'projects.researchAssistant.analyticalVariable.definition.timeWindow': 'Time Window',
  'projects.researchAssistant.analyticalVariable.definition.patientLevelAggregation':
    'Patient-Level Aggregation',
  'projects.researchAssistant.analyticalVariable.definition.aggregationMethod':
    'Aggregation method:',

  // SQL Tab
  'projects.researchAssistant.analyticalVariable.sql.generatedSql': 'Generated SQL',
  'projects.researchAssistant.analyticalVariable.sql.sqlDetails': 'SQL Details',
  'projects.researchAssistant.analyticalVariable.sql.detail1':
    'Query returns DISTINCT patient IDs to ensure patient-level aggregation',
  'projects.researchAssistant.analyticalVariable.sql.detail2':
    'CTEs (Common Table Expressions) are used for modular, readable SQL',
  'projects.researchAssistant.analyticalVariable.sql.detail3':
    'Filters are applied based on OMOP CDM concept mappings',
  'projects.researchAssistant.analyticalVariable.sql.detail4':
    'Results can be executed against any OMOP-compliant database',
  'projects.researchAssistant.analyticalVariable.copySql': 'Copy SQL',

  // Data Tab
  'projects.researchAssistant.analyticalVariable.data.title': 'Data Preview',
  'projects.researchAssistant.analyticalVariable.data.sampleRecords':
    'Sample of {count} patient records',
  'projects.researchAssistant.analyticalVariable.data.personId': 'Person ID',
  'projects.researchAssistant.analyticalVariable.data.valueBoolean': 'Value (boolean)',
  'projects.researchAssistant.analyticalVariable.data.previewNote': 'Preview Note:',
  'projects.researchAssistant.analyticalVariable.data.previewNoteDescription':
    'This is simulated preview data. Connect to a real OMOP CDM database to execute the SQL query and view actual patient records.',
  'projects.researchAssistant.analyticalVariable.refresh': 'Refresh',

  // Verification Tab
  'projects.researchAssistant.analyticalVariable.verification.keyMetrics': 'Key Metrics',
  'projects.researchAssistant.analyticalVariable.verification.totalPatients': 'Total Patients',
  'projects.researchAssistant.analyticalVariable.verification.uniqueValues': 'Unique Values',
  'projects.researchAssistant.analyticalVariable.verification.nullMissing': 'Null/Missing',
  'projects.researchAssistant.analyticalVariable.verification.dataQualityChecks':
    'Data Quality Checks',
  'projects.researchAssistant.analyticalVariable.verification.check1': 'Patient IDs are unique',
  'projects.researchAssistant.analyticalVariable.verification.check2':
    'Output type matches specification (boolean)',
  'projects.researchAssistant.analyticalVariable.verification.check3':
    'Missing data is within acceptable threshold (5%)',
  'projects.researchAssistant.analyticalVariable.verification.check4':
    '{uniqueValues} distinct values across {totalPatients} patients',
  'projects.researchAssistant.analyticalVariable.verification.valueDistribution':
    'Value Distribution',
  'projects.researchAssistant.analyticalVariable.verification.chartPlaceholder':
    'Chart visualization will be implemented here',
  'projects.researchAssistant.analyticalVariable.verification.trueCount': 'True: {count}',
  'projects.researchAssistant.analyticalVariable.verification.falseCount': 'False: {count}',
  'projects.researchAssistant.analyticalVariable.verification.validationPassed':
    'Verification Passed',
  'projects.researchAssistant.analyticalVariable.verification.validationPassedDescription':
    'This variable meets all data quality standards and is ready for use in clinical studies.',

  // Detail Modal (read-only view from criteria card)
  'projects.analyticalVariables.detailModal.description': 'Description',
  'projects.analyticalVariables.detailModal.logicDynamic': '{name} is defined as',
  'projects.analyticalVariables.detailModal.noLogic': 'No logic defined',
  'projects.analyticalVariables.detailModal.format': 'Format',
  'projects.analyticalVariables.detailModal.category': 'Category:',
  'projects.analyticalVariables.detailModal.category.clinical': 'Clinical',
  'projects.analyticalVariables.detailModal.category.demographic': 'Demographic',
  'projects.analyticalVariables.detailModal.category.observability': 'Observability',
  'projects.analyticalVariables.detailModal.owner': 'Owner:',
  'projects.analyticalVariables.detailModal.lastModified': 'Last modified:',
  'projects.analyticalVariables.detailModal.noDescription': 'No description',

  // Logic card – domain labels (keyed by OmopTable enum values)
  'projects.analyticalVariables.logic.domain.person': 'Person',
  'projects.analyticalVariables.logic.domain.observation_period': 'Observation period',
  'projects.analyticalVariables.logic.domain.condition_occurrence': 'Condition',
  'projects.analyticalVariables.logic.domain.condition_era': 'Condition era',
  'projects.analyticalVariables.logic.domain.drug_exposure': 'Drug',
  'projects.analyticalVariables.logic.domain.drug_era': 'Drug era',
  'projects.analyticalVariables.logic.domain.dose_era': 'Dose era',
  'projects.analyticalVariables.logic.domain.procedure_occurrence': 'Procedure',
  'projects.analyticalVariables.logic.domain.device_exposure': 'Device',
  'projects.analyticalVariables.logic.domain.measurement': 'Measurement',
  'projects.analyticalVariables.logic.domain.observation': 'Observation',
  'projects.analyticalVariables.logic.domain.death': 'Death',
  'projects.analyticalVariables.logic.domain.visit_occurrence': 'Visit',
  'projects.analyticalVariables.logic.domain.visit_detail': 'Visit detail',
  'projects.analyticalVariables.logic.domain.note': 'Note',
  'projects.analyticalVariables.logic.domain.note_nlp': 'Note NLP',
  'projects.analyticalVariables.logic.domain.specimen': 'Specimen',
  'projects.analyticalVariables.logic.domain.episode': 'Episode',
  'projects.analyticalVariables.logic.domain.episode_event': 'Episode event',
  'projects.analyticalVariables.logic.domain.payer_plan_period': 'Payer plan period',
  'projects.analyticalVariables.logic.domain.cost': 'Cost',
  'projects.analyticalVariables.logic.domain.provider': 'Provider',

  // Logic card – domain labels (keyed by OmopTable enum values)
  'projects.analyticalVariables.logic.table.person': 'person',
  'projects.analyticalVariables.logic.table.observation_period': 'observation period',
  'projects.analyticalVariables.logic.table.condition_occurrence': 'condition occurrence',
  'projects.analyticalVariables.logic.table.condition_era': 'condition era',
  'projects.analyticalVariables.logic.table.drug_exposure': 'drug exposure',
  'projects.analyticalVariables.logic.table.drug_era': 'drug era',
  'projects.analyticalVariables.logic.table.dose_era': 'dose era',
  'projects.analyticalVariables.logic.table.procedure_occurrence': 'procedure occurrence',
  'projects.analyticalVariables.logic.table.device_exposure': 'device exposure',
  'projects.analyticalVariables.logic.table.measurement': 'measurement',
  'projects.analyticalVariables.logic.table.observation': 'observation',
  'projects.analyticalVariables.logic.table.death': 'death',
  'projects.analyticalVariables.logic.table.visit_occurrence': 'visit occurrence',
  'projects.analyticalVariables.logic.table.visit_detail': 'visit detail',
  'projects.analyticalVariables.logic.table.note': 'note',
  'projects.analyticalVariables.logic.table.note_nlp': 'note nlp',
  'projects.analyticalVariables.logic.table.specimen': 'specimen',
  'projects.analyticalVariables.logic.table.episode': 'episode',
  'projects.analyticalVariables.logic.table.episode_event': 'episode event',
  'projects.analyticalVariables.logic.table.payer_plan_period': 'payer plan period',
  'projects.analyticalVariables.logic.table.cost': 'cost',
  'projects.analyticalVariables.logic.table.provider': 'provider',

  // Logic card – concept ref row labels
  'projects.analyticalVariables.logic.domainMatching': '{domain} matching',

  // Logic card – DomainFilter numeric field labels
  'projects.analyticalVariables.logic.fieldValue': 'Value {filter}',
  'projects.analyticalVariables.logic.fieldDaysSupply': 'Days supply {filter}',
  'projects.analyticalVariables.logic.fieldAge': 'Age {filter}',

  // Logic card – operators
  'projects.analyticalVariables.logic.andOperator': 'AND',

  // Logic card – numeric formatting
  'projects.analyticalVariables.logic.numericBetween': 'between {low} and {high}',
  'projects.analyticalVariables.logic.numericNotBetween': 'not between {low} and {high}',

  // Logic card – correlated relationship labels
  'projects.analyticalVariables.logic.relationship.default': 'WITH',
  'projects.analyticalVariables.logic.relationship.same_visit': 'SAME VISIT',
  'projects.analyticalVariables.logic.relationship.same_episode': 'SAME EPISODE',
  'projects.analyticalVariables.logic.relationship.temporal_during': 'TEMPORAL DURING',
  'projects.analyticalVariables.logic.relationship.same_person_temporal': 'SAME PERSON TEMPORAL',

  // Logic card – concept group resolution
  'projects.analyticalVariables.logic.conceptGroupUnavailable': 'Concept group not available',
  'projects.analyticalVariables.logic.resolvingConceptGroups': 'Resolving concept groups...',
  'projects.analyticalVariables.logic.savingTooltip': 'Saving changes…',
  'projects.analyticalVariables.logic.updatedBadge': 'Updated',

  // Logic card – temporal relationship formatting
  'projects.analyticalVariables.logic.relationshipWithGaps': '{relationship} ({gaps})',
  'projects.analyticalVariables.logic.minGap': 'min {value} {unit}',
  'projects.analyticalVariables.logic.maxGap': 'within {value} {unit}',
  'projects.analyticalVariables.logic.defaultTimeUnit': 'days',
  'projects.analyticalVariables.logic.temporalAfterRange':
    'from {minGap} to {maxGap} {unit} after occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalAtLeastAfter':
    'at least {minGap} {unit} after occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalOnOrAfter': 'on or after occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalDuring': 'occurs during occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalOverlaps': 'overlaps with occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalWithin':
    'within {maxGap} {unit} of occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalBetweenOf':
    'between {minGap} and {maxGap} {unit} of occurrence {occurrence}',
  'projects.analyticalVariables.logic.temporalAwayFrom':
    'at least {minGap} {unit} away from occurrence {occurrence}',
  'projects.analyticalVariables.logic.tableRecord': 'Any {table} record where',
  'projects.analyticalVariables.logic.allTableRecords': 'All {table} records',

  // Drill-down disabled tooltips
  'projects.analyticalVariables.drillDown.disabled.unresolvedConceptGroups':
    'Unresolved concept groups detected. Edit the logic to resolve.',
  'projects.analyticalVariables.drillDown.disabled.validating': 'Checking logic translation…',
  'projects.analyticalVariables.drillDown.disabled.translationFailed':
    'Logic translation failed. Check the analytical variable configuration.',

  // AvContentCard header
  'projects.analyticalVariables.contentCard.statusChip.working': 'Working…',
  'projects.analyticalVariables.contentCard.statusChip.drafting': 'Drafting',
  'projects.analyticalVariables.contentCard.statusChip.verified': 'Verified',
  'projects.analyticalVariables.contentCard.statusChip.error': 'Error',
  'projects.analyticalVariables.contentCard.statusChip.saved': 'Saved',
  'projects.analyticalVariables.contentCard.meta.scope.project': 'Project',
  'projects.analyticalVariables.contentCard.meta.scope.organization': 'Org',

  // AvScopeControl
  'projects.analyticalVariables.scopeControl.shareWithOrg': 'Share with organization',
  'projects.analyticalVariables.scopeControl.updating': 'Updating…',
  'projects.analyticalVariables.scopeControl.tooltip.shareWithOrg':
    'Make this variable visible to other projects in your organization.',
  'projects.analyticalVariables.scopeControl.tooltip.notReady':
    'Cannot share until the variable is in Ready status.',
  'projects.analyticalVariables.scopeControl.tooltip.notCreator':
    'Only the variable owner can share this variable to the organization.',
  'projects.analyticalVariables.scopeControl.tooltip.alreadyShared':
    'This variable has already been shared with your organization.',
  'projects.analyticalVariables.scopeControl.confirmDialog.title': 'Share with organization',
  'projects.analyticalVariables.scopeControl.confirmDialog.messageTitle': 'Confirm selection',
  'projects.analyticalVariables.scopeControl.confirmDialog.messageText':
    'This will make "{name}" available in all projects in your organization. Once used outside of this project, the scope cannot be changed.',
  'projects.analyticalVariables.scopeControl.confirmDialog.cancelButton': 'Cancel',
  'projects.analyticalVariables.scopeControl.confirmDialog.confirmButton': 'Share',
  'projects.analyticalVariables.scopeControl.confirmDialog.successTitle': 'Success',
  'projects.analyticalVariables.scopeControl.confirmDialog.successText':
    '"{name}" was shared successfully and is now available to all projects in your organization.',
  'projects.analyticalVariables.scopeControl.confirmDialog.autoCloseCountdown':
    'This window will close automatically in {seconds} seconds.',
  'projects.analyticalVariables.scopeControl.error.generic': 'Could not update the variable scope.',

  // Rename dialog (OR-6090) — shared by the AV list page and the project
  // artifact list row actions.
  'projects.analyticalVariables.actionMenu.rename.label': 'Rename',
  // OR-6234: delete a variable that nothing uses (owner only)
  'projects.analyticalVariables.actionMenu.delete.label': 'Delete',
  'projects.analyticalVariables.deleteModal.title': 'Delete variable',
  'projects.analyticalVariables.deleteModal.inUseTitle': 'Variable in use',
  'projects.analyticalVariables.deleteModal.confirmTitle': 'Confirm delete',
  'projects.analyticalVariables.deleteModal.actionUndone': 'This action cannot be undone.',
  'projects.analyticalVariables.deleteModal.description':
    'This action will permanently delete {variableName}.',
  'projects.analyticalVariables.deleteModal.editInProgress':
    'This variable has an edit in progress. Deleting it discards that edit as well.',
  'projects.analyticalVariables.deleteModal.inUseError': 'Cannot delete variable',
  'projects.analyticalVariables.deleteModal.checkFailedTitle':
    'Could not check what uses this variable',
  'projects.analyticalVariables.deleteModal.checkFailedDescription':
    'Deleting stays unavailable until the check answers, so a variable something still depends on is never removed by mistake.',
  'projects.analyticalVariables.deleteModal.retryButton': 'Try again',
  'projects.analyticalVariables.deleteModal.inUseDescription':
    'This variable is still used by the following.',
  'projects.analyticalVariables.deleteModal.usage.cohort': 'Cohort',
  'projects.analyticalVariables.deleteModal.usage.analytical_dataset': 'Analytical dataset',
  'projects.analyticalVariables.deleteModal.usage.analytical_variable': 'Variable',
  'projects.analyticalVariables.deleteModal.cancelButton': 'Cancel',
  'projects.analyticalVariables.deleteModal.deleteButton': 'Delete variable',
  'projects.analyticalVariables.deleteModal.submitting': 'Deleting variable',
  'projects.analyticalVariables.deleteModal.closeButton': 'Close',
  'projects.analyticalVariables.deleteModal.submittingError': 'Error',
  'projects.analyticalVariables.deleteModal.success.title': 'Variable deleted',
  'projects.analyticalVariables.deleteModal.success.text':
    'The variable {variableName} has been deleted.',
  'projects.analyticalVariables.renameModal.title': 'Rename variable',
  'projects.analyticalVariables.renameModal.name.label': 'Name',
  'projects.analyticalVariables.renameModal.name.placeholder': 'Enter a variable name',
  'projects.analyticalVariables.renameModal.invalidCharacterErrorMsg':
    'Name contains an unsupported character.',
  'projects.analyticalVariables.renameModal.cancelButton': 'Cancel',
  'projects.analyticalVariables.renameModal.renameButton': 'Rename',
  'projects.analyticalVariables.renameModal.submitting': 'Renaming…',
  'projects.analyticalVariables.renameModal.closeButton': 'Close',
  'projects.analyticalVariables.renameModal.submittingError': "Couldn't rename the variable",
  'projects.analyticalVariables.renameModal.success.title': 'Success',
  'projects.analyticalVariables.renameModal.success.text': 'Renamed to "{name}".',

  // Inline rename on the variable detail page (OR-6090 AC1c)
  'projects.analyticalVariables.renameInline.editAria': 'Edit variable name',
  'projects.analyticalVariables.renameInline.saveAria': 'Save name',
  'projects.analyticalVariables.renameInline.cancelAria': 'Cancel editing name',
  'projects.analyticalVariables.renameInline.invalidCharacterErrorMsg':
    'Name contains an unsupported character.',
};
